import React, { Component } from 'react'
import PropTypes from 'prop-types'
import SearchMadesResult from './SearchMadesResult'

class SearchMadesWrapper extends Component {
  static propTypes = {
    searchMades: PropTypes.array.isRequired,
  }

  render() {
    const { searchMades } = this.props
    return searchMades.map(searchMade => <SearchMadesResult key={searchMade._id} searchMade={searchMade}/>)
  }
}

export default SearchMadesWrapper



// WEBPACK FOOTER //
// ./src/components/ui/SearchHistory/SearchMades/SearchMadesWrapper.js